<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add Ward</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="ward.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="ward.code" />
                                    <validation-error :errors="apiValidationErrors.code" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Postal Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="ward.postal_code" />
                                    <validation-error :errors="apiValidationErrors.postal_code" />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                District
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="ward.district_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="District Type"
                                        placeholder="Select Regions"
                                        :options="available_district_dropdown"
                                        :allow-empty="false">
                                </select-input>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Ward</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInput from '../../../components/Inputs/SelectInput';
export default {
    components: { ValidationError, SelectInput },

    mixins: [formMixin],

    data: () => ({


        ward: {
            type:'wards',
            name:null,
            code:null,
            postal_code: null,
            district_id: null,
        },

        available_district_dropdown: []
    }),
    created () {
        this.getZoneDistrictDowns();
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('wards/add',  this.ward);
                this.notifySuccess('Ward added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        async getZoneDistrictDowns () {
            await this.$store.dispatch('districts/list');
            this.available_district_dropdown =  await this.$store.getters['districts/list'];
        },

        goBack () {
            this.$router.push({ name: 'Wards List' });
        },

    },
};
</script>
